import { PillSelect } from "@/components/we360/PillSelect";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { FREQ_DIET, FOOD_ITEMS, scoreItem, classifyDiet } from "./helpers";

const ITEMS_2 = FOOD_ITEMS.slice(5, 10);

export default function Step2Consumption2({ answers, onChange, allAnswered, dietScore, errors }) {
  const dietClass = allAnswered ? classifyDiet(dietScore) : null;

  return (
    <div>
      <div
        className="rounded-[14px] p-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#FCFAEE", border: "1px solid #E2D9CB", color: "#2D2A24" }}
      >
        Continua respondiendo sobre tu consumo en una <strong>semana normal</strong>.
      </div>

      {ITEMS_2.map((item) => (
        <div key={item.id} className="mb-4">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs font-semibold" style={{ color: "#2D2A24" }}>{item.label}</span>
            {item.inverse && (
              <span
                className="text-[9px] font-bold px-2 py-0.5 rounded-lg shrink-0"
                style={{ background: "#FFF3DC", color: "#F9A01B" }}
                data-testid={`f4-tag-${item.id}`}
              >
                a limitar
              </span>
            )}
          </div>
          <PillSelect
            options={FREQ_DIET.map((f) => f)}
            value={answers[item.id] ?? ""}
            onChange={(v) => onChange(item.id, v)}
            error={errors?.getError(`food_${item.id}`)}
            testId={`f4-food-${item.id}`}
            columns={1}
          />
        </div>
      ))}

      {allAnswered && dietClass && (
        <CalculatedBadge
          label="Calidad de dieta"
          value={`${dietScore}/40`}
          category={dietClass.label}
          categoryColor={dietClass.color}
          testId="badge-calidad-dieta"
        />
      )}
    </div>
  );
}
